import { render, staticRenderFns } from "./RegisterLessonBasic.vue?vue&type=template&id=24ff95b2&scoped=true&"
import script from "./RegisterLessonBasic.vue?vue&type=script&lang=js&"
export * from "./RegisterLessonBasic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLessonBasic.vue?vue&type=style&index=0&id=24ff95b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff95b2",
  null
  
)

export default component.exports